import '../style/styleDefault.css'
import '../style/styleMobile.css'
import '../style/styleOrdi.css'
import '../style/styleTab.css'
import cropped_logo_lopcus from '../ressources/cropped-logo_lopcus_couleur_small.png'
import { default as translate } from '../i18n/translate'

function Contact() {
  
    return (
        <div>
          <div className="container" style={{textAlign: "center"}}>
              <div style={{marginTop: "65px"}}></div>
              <img src={cropped_logo_lopcus} alt="logo" style={{width: "95px"}}/>
              <h1>{translate("contact.envoyer_commentaire")}</h1>
          </div>
          <div id="contact-form" className="green-card" style={{maxWidth: "600px", margin: "auto", fonSize: "22px"}}>
              <i className="fa fa-map-marker"></i>
              <b>{translate("contact.nom_fmss")}</b>
              <b>{translate("contact.adresse_ami")}</b>
              <br/>
              <i className="fa fa-phone" aria-hidden="true"></i>
              <b>{translate("contact.telephone_ami")}</b>
              <br/>
              <i className="fa fa-envelope" aria-hidden="true"></i>
              <a href="mailto: Chantal.Viscogliosi@USherbrooke.ca">{translate("contact.email_ami")}</a>
              <br/>
              <div className="container-small" style={{display: "none"}}>
                  <label id="email_from">{translate("contact.votre_email")}</label>
                  <input id="email_from" type="email" className="form-control m-t-10 p-r-l" v-model="email_from"/>
                  <br/>
                  <label id="nom">{translate("contact.votre_nom")}</label>
                  <input id="nom" className="form-control m-t-10 p-r-l" v-model="nom"/>
                  <br/>
                  <label id="message">{translate("contact.votre_commentaire")}</label>
                  <textarea id="message" className="form-control p-r-l" v-model="message" style={{width: "100%", marginTop: "10px", height: "150px"}}></textarea>
                  <button className="default" click="send_message">{translate("contact.envoyer")}</button>
              </div>
          </div>
          {/* <contactForm/> */}
        </div>
    );
  }
  export default Contact;